/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BasicPricePropertiesDto } from '../models';
// @ts-ignore
import type { ConditionalPriceContainerIdDto } from '../models';
// @ts-ignore
import type { ConditionalPriceContainerPropertiesDto } from '../models';
// @ts-ignore
import type { ConditionalPriceIdDto } from '../models';
// @ts-ignore
import type { ConditionalPricePropertiesDto } from '../models';
// @ts-ignore
import type { PriceIdDto } from '../models';
/**
 * RestComponentDefinitionPricesApi - axios parameter creator
 */
export const RestComponentDefinitionPricesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add conditional prices container to component definition
         * @param {number} componentDefinitionId 
         * @param {ConditionalPriceContainerPropertiesDto} conditionalPriceContainerPropertiesDto Component definition conditional prices container creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinitionConditionalPricesContainer: async (componentDefinitionId: number, conditionalPriceContainerPropertiesDto: ConditionalPriceContainerPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentDefinitionId' is not null or undefined
            assertParamExists('createComponentDefinitionConditionalPricesContainer', 'componentDefinitionId', componentDefinitionId)
            // verify required parameter 'conditionalPriceContainerPropertiesDto' is not null or undefined
            assertParamExists('createComponentDefinitionConditionalPricesContainer', 'conditionalPriceContainerPropertiesDto', conditionalPriceContainerPropertiesDto)
            const localVarPath = `/api/component-definitions/{componentDefinitionId}/conditional-prices-containers`
                .replace('{componentDefinitionId}', encodeURIComponent(String(componentDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conditionalPriceContainerPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add conditional prices container to component definition
         * @param {number} componentDefinitionId 
         * @param {number} conditionalContainerPriceId 
         * @param {ConditionalPricePropertiesDto} conditionalPricePropertiesDto Component definition conditional prices container price creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinitionConditionalPricesContainerPrice: async (componentDefinitionId: number, conditionalContainerPriceId: number, conditionalPricePropertiesDto: ConditionalPricePropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentDefinitionId' is not null or undefined
            assertParamExists('createComponentDefinitionConditionalPricesContainerPrice', 'componentDefinitionId', componentDefinitionId)
            // verify required parameter 'conditionalContainerPriceId' is not null or undefined
            assertParamExists('createComponentDefinitionConditionalPricesContainerPrice', 'conditionalContainerPriceId', conditionalContainerPriceId)
            // verify required parameter 'conditionalPricePropertiesDto' is not null or undefined
            assertParamExists('createComponentDefinitionConditionalPricesContainerPrice', 'conditionalPricePropertiesDto', conditionalPricePropertiesDto)
            const localVarPath = `/api/component-definitions/{componentDefinitionId}/conditional-prices-containers/{conditionalContainerPriceId}/conditional-prices`
                .replace('{componentDefinitionId}', encodeURIComponent(String(componentDefinitionId)))
                .replace('{conditionalContainerPriceId}', encodeURIComponent(String(conditionalContainerPriceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conditionalPricePropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add basic price to component definition
         * @param {number} componentDefinitionId 
         * @param {BasicPricePropertiesDto} basicPricePropertiesDto Component definition price creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinitionPrice: async (componentDefinitionId: number, basicPricePropertiesDto: BasicPricePropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentDefinitionId' is not null or undefined
            assertParamExists('createComponentDefinitionPrice', 'componentDefinitionId', componentDefinitionId)
            // verify required parameter 'basicPricePropertiesDto' is not null or undefined
            assertParamExists('createComponentDefinitionPrice', 'basicPricePropertiesDto', basicPricePropertiesDto)
            const localVarPath = `/api/component-definitions/{componentDefinitionId}/basic-prices`
                .replace('{componentDefinitionId}', encodeURIComponent(String(componentDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(basicPricePropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestComponentDefinitionPricesApi - functional programming interface
 */
export const RestComponentDefinitionPricesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestComponentDefinitionPricesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add conditional prices container to component definition
         * @param {number} componentDefinitionId 
         * @param {ConditionalPriceContainerPropertiesDto} conditionalPriceContainerPropertiesDto Component definition conditional prices container creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComponentDefinitionConditionalPricesContainer(componentDefinitionId: number, conditionalPriceContainerPropertiesDto: ConditionalPriceContainerPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConditionalPriceContainerIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComponentDefinitionConditionalPricesContainer(componentDefinitionId, conditionalPriceContainerPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentDefinitionPricesApi.createComponentDefinitionConditionalPricesContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add conditional prices container to component definition
         * @param {number} componentDefinitionId 
         * @param {number} conditionalContainerPriceId 
         * @param {ConditionalPricePropertiesDto} conditionalPricePropertiesDto Component definition conditional prices container price creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComponentDefinitionConditionalPricesContainerPrice(componentDefinitionId: number, conditionalContainerPriceId: number, conditionalPricePropertiesDto: ConditionalPricePropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConditionalPriceIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComponentDefinitionConditionalPricesContainerPrice(componentDefinitionId, conditionalContainerPriceId, conditionalPricePropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentDefinitionPricesApi.createComponentDefinitionConditionalPricesContainerPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add basic price to component definition
         * @param {number} componentDefinitionId 
         * @param {BasicPricePropertiesDto} basicPricePropertiesDto Component definition price creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComponentDefinitionPrice(componentDefinitionId: number, basicPricePropertiesDto: BasicPricePropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComponentDefinitionPrice(componentDefinitionId, basicPricePropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentDefinitionPricesApi.createComponentDefinitionPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestComponentDefinitionPricesApi - factory interface
 */
export const RestComponentDefinitionPricesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestComponentDefinitionPricesApiFp(configuration)
    return {
        /**
         * 
         * @summary Add conditional prices container to component definition
         * @param {number} componentDefinitionId 
         * @param {ConditionalPriceContainerPropertiesDto} conditionalPriceContainerPropertiesDto Component definition conditional prices container creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinitionConditionalPricesContainer(componentDefinitionId: number, conditionalPriceContainerPropertiesDto: ConditionalPriceContainerPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<ConditionalPriceContainerIdDto> {
            return localVarFp.createComponentDefinitionConditionalPricesContainer(componentDefinitionId, conditionalPriceContainerPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add conditional prices container to component definition
         * @param {number} componentDefinitionId 
         * @param {number} conditionalContainerPriceId 
         * @param {ConditionalPricePropertiesDto} conditionalPricePropertiesDto Component definition conditional prices container price creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinitionConditionalPricesContainerPrice(componentDefinitionId: number, conditionalContainerPriceId: number, conditionalPricePropertiesDto: ConditionalPricePropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<ConditionalPriceIdDto> {
            return localVarFp.createComponentDefinitionConditionalPricesContainerPrice(componentDefinitionId, conditionalContainerPriceId, conditionalPricePropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add basic price to component definition
         * @param {number} componentDefinitionId 
         * @param {BasicPricePropertiesDto} basicPricePropertiesDto Component definition price creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinitionPrice(componentDefinitionId: number, basicPricePropertiesDto: BasicPricePropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<PriceIdDto> {
            return localVarFp.createComponentDefinitionPrice(componentDefinitionId, basicPricePropertiesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestComponentDefinitionPricesApi - interface
 */
export interface RestComponentDefinitionPricesApiInterface {
    /**
     * 
     * @summary Add conditional prices container to component definition
     * @param {number} componentDefinitionId 
     * @param {ConditionalPriceContainerPropertiesDto} conditionalPriceContainerPropertiesDto Component definition conditional prices container creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComponentDefinitionConditionalPricesContainer(componentDefinitionId: number, conditionalPriceContainerPropertiesDto: ConditionalPriceContainerPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<ConditionalPriceContainerIdDto>;

    /**
     * 
     * @summary Add conditional prices container to component definition
     * @param {number} componentDefinitionId 
     * @param {number} conditionalContainerPriceId 
     * @param {ConditionalPricePropertiesDto} conditionalPricePropertiesDto Component definition conditional prices container price creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComponentDefinitionConditionalPricesContainerPrice(componentDefinitionId: number, conditionalContainerPriceId: number, conditionalPricePropertiesDto: ConditionalPricePropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<ConditionalPriceIdDto>;

    /**
     * 
     * @summary Add basic price to component definition
     * @param {number} componentDefinitionId 
     * @param {BasicPricePropertiesDto} basicPricePropertiesDto Component definition price creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComponentDefinitionPrice(componentDefinitionId: number, basicPricePropertiesDto: BasicPricePropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<PriceIdDto>;

}

/**
 * RestComponentDefinitionPricesApi - object-oriented interface
 */
export class RestComponentDefinitionPricesApi extends BaseAPI implements RestComponentDefinitionPricesApiInterface {
    /**
     * 
     * @summary Add conditional prices container to component definition
     * @param {number} componentDefinitionId 
     * @param {ConditionalPriceContainerPropertiesDto} conditionalPriceContainerPropertiesDto Component definition conditional prices container creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComponentDefinitionConditionalPricesContainer(componentDefinitionId: number, conditionalPriceContainerPropertiesDto: ConditionalPriceContainerPropertiesDto, options?: RawAxiosRequestConfig) {
        return RestComponentDefinitionPricesApiFp(this.configuration).createComponentDefinitionConditionalPricesContainer(componentDefinitionId, conditionalPriceContainerPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add conditional prices container to component definition
     * @param {number} componentDefinitionId 
     * @param {number} conditionalContainerPriceId 
     * @param {ConditionalPricePropertiesDto} conditionalPricePropertiesDto Component definition conditional prices container price creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComponentDefinitionConditionalPricesContainerPrice(componentDefinitionId: number, conditionalContainerPriceId: number, conditionalPricePropertiesDto: ConditionalPricePropertiesDto, options?: RawAxiosRequestConfig) {
        return RestComponentDefinitionPricesApiFp(this.configuration).createComponentDefinitionConditionalPricesContainerPrice(componentDefinitionId, conditionalContainerPriceId, conditionalPricePropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add basic price to component definition
     * @param {number} componentDefinitionId 
     * @param {BasicPricePropertiesDto} basicPricePropertiesDto Component definition price creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComponentDefinitionPrice(componentDefinitionId: number, basicPricePropertiesDto: BasicPricePropertiesDto, options?: RawAxiosRequestConfig) {
        return RestComponentDefinitionPricesApiFp(this.configuration).createComponentDefinitionPrice(componentDefinitionId, basicPricePropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }
}

